import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FaHistory, FaShoppingCart, FaListAlt, FaShoppingBag } from 'react-icons/fa';
import '../styles/WalletHistoryPage.css';

const WalletHistoryPage = () => {
  return (
    <div className="history-page-container">
      {/* Hero Section */}
      <div className="history-hero">
        <h1 className="history-hero-title">
          <FaHistory className="history-hero-icon" />
          Transaction History
        </h1>
        <p className="history-hero-subtitle">
          View your sales, listings, and purchases on KleverChain
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="history-tab-navigation">
        <NavLink
          to="sales"
          className={({ isActive }) => `history-tab-item ${isActive ? 'active' : ''}`}
        >
          <FaShoppingCart className="tab-icon" />
          <span>Sales</span>
        </NavLink>
        <NavLink
          to="listings"
          className={({ isActive }) => `history-tab-item ${isActive ? 'active' : ''}`}
        >
          <FaListAlt className="tab-icon" />
          <span>Listings</span>
        </NavLink>
        <NavLink
          to="purchases"
          className={({ isActive }) => `history-tab-item ${isActive ? 'active' : ''}`}
        >
          <FaShoppingBag className="tab-icon" />
          <span>Purchases</span>
        </NavLink>
      </div>

      {/* Content Area (Outlet for nested routes) */}
      <div className="history-content">
        <Outlet />
      </div>
    </div>
  );
};

export default WalletHistoryPage;